import { render, staticRenderFns } from "./new-dashboard.vue?vue&type=template&id=2f161f97&scoped=true"
import script from "./new-dashboard.vue?vue&type=script&lang=js"
export * from "./new-dashboard.vue?vue&type=script&lang=js"
import style0 from "./new-dashboard.vue?vue&type=style&index=0&id=2f161f97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f161f97",
  null
  
)

export default component.exports